import React from "react";
import { Modal, Button } from "semantic-ui-react";
import { QRCodeCanvas } from "qrcode.react";

function CodeModal({ showCode, setShowCode }) {
  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = `${showCode?.names}_QR_Code.png`;
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  return (
    <Modal
      size="mini"
      open={showCode.show}
      style={{
        position: "relative",
        height: "63vh",
      }}
      onClose={() => setShowCode({ show: false })}
    >
      <Modal.Header>New Student QR Code</Modal.Header>
      <Modal.Content>
        <QRCodeCanvas value={showCode.data} id="qrCodeEl" size={250} />
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={() => setShowCode({ show: false })}>
          Dismiss
        </Button>
        <Button positive onClick={downloadQRCode}>
          Download image
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default CodeModal;
